import angular = require("angular");

class ReusableModalController implements angular.IComponentController {
  public title: string;
  public onAccept: any;
  public onCancel: any;
  public acceptButtonText: string = "Save";
  public cancelButtonText: string = "Cancel";
  public isLoading: boolean = false;
  /** Indeterminate bar only (e.g. background client list load); does not disable actions. */
  public showProgressLoading: boolean = false;
  public acceptDisabled: boolean = false;
  public acceptDisabledMessage: string = "";

  $onInit() {
    // Component bindings are automatically available
  }

  public handleAccept() {
    if (this.onAccept) {
      this.onAccept();
    }
  }

  public handleCancel() {
    if (this.onCancel) {
      this.onCancel();
    }
  }
}

export const reusableModal: angular.IComponentOptions = {
  template: require("./reusable-modal.component.html"),
  controller: ReusableModalController,
    bindings: {
    title: "@",
    onAccept: "&?",
    onCancel: "&",
    acceptButtonText: "@?",
    cancelButtonText: "@?",
    isLoading: "<?",
    showProgressLoading: "<?",
    acceptDisabled: "<?",
    acceptDisabledMessage: "@?"
  },
  transclude: true
};



// WEBPACK FOOTER //
// ./src/components/reusable-modal/reusable-modal.component.ts